module.exports = __webpack_public_path__ + "static/img/icon-1.35ee648d.png";